// CallToAction.js
import React from "react";
import { Link } from "react-router-dom"; // ← ここが重要！

const CallToAction = () => {
  return (
    <section className=" text-white py-12 px-6 text-center font-serif">
      <h2 className="text-[clamp(20px,8vw,24px)] md:text-4xl font-bold mb-4">
        最適な防犯カメラを今すぐ診断！
      </h2>
      <p className="text-lg md:text-xl mb-8">8つの質問に直感的に答えるだけで、</p>
      <div className="flex flex-col md:flex-row justify-center items-center gap-4">
        <Link to="/wizard">
          <div className="bg-white m-auto text-gray-900 font-semibold px-6 py-3 rounded-2 hover:bg-gray-200 transition cursor-pointer">
            無料診断スタート
          </div>
        </Link>
        <Link to="/contact">
          <div className="border border-white text-white px-6 py-3 rounded-2 hover:bg-white hover:text-gray-900 transition cursor-pointer">
            お問い合わせはこちら
          </div>
        </Link>
      </div>
    </section>
  );
};

export default CallToAction;
